import { APP_VENDOR, MAIN_SITE_HOMEPAGE } from 'config';
import { DepositModeKey } from './recharges.types';

export const topupRequestEndpoint = '/cashier-core-ms/v1/topup/request';

export const topupActivationEndpoint = '/cashier-core-ms/v1/topup/activation';

export const depositVerifyCodeEndpoint = '/bonus-ms/v1/topup/verifyCode';

export const topupMethodsEndpoint = '/cashier-core-ms/v1/topup/methods';

export const DepositMode = {
  default: '0_0',
  postePostpay: '2_1',
  bankTransfer: '1_9',
  voucherEpay: '_1_9',
  pdV: '8_100',
  safeChargeMasterCard: '9_1',
  safeChargeVisa: '9_2',
  safeChargePaypal: '9_3',
  safeChargePaysafe: '9_4',
  safeChargeNeteller: '9_5',
  safeChargeSkrill: '9_6',
  safeChargeSkrillOneTap: '9_7',
  applepay: '9_8',
  directBankTransfer: '9_9',
  safeChargeMasterCardAutomaticActivation: '10_1',
  safeChargeVisaAutomaticActivation: '10_2',
  safeChargeMasterCardAutomatic: '11_1',
  safeChargeVisaAutomatic: '11_2',
  mbWay: '9_31',
  bizum: '9_20',
  multibanco: '9_30',
  applepayAutomatic: '11_8',
} as const;

export const rechargeMethodToAnalyticName = {
  [DepositMode.default]: '',
  [DepositMode.pdV]: 'pdv',
  [DepositMode.safeChargeVisa]: 'visa',
  [DepositMode.safeChargeMasterCard]: 'mastercard',
  [DepositMode.postePostpay]: 'postepay',
  [DepositMode.safeChargeSkrill]: 'skrill',
  [DepositMode.safeChargeSkrillOneTap]: 'skrill_tap',
  [DepositMode.safeChargeNeteller]: 'neteller',
  [DepositMode.safeChargePaypal]: 'paypal',
  [DepositMode.safeChargePaysafe]: 'paysafecard',
  [DepositMode.voucherEpay]: 'voucher_epay',
  [DepositMode.bankTransfer]: 'bonifico',
  [DepositMode.directBankTransfer]: 'bonifico_diretto',
  [DepositMode.applepay]: 'applepay',
  [DepositMode.safeChargeMasterCardAutomaticActivation]: 'mastercard_automatic',
  [DepositMode.safeChargeVisaAutomaticActivation]: 'visa_automatic',
  [DepositMode.safeChargeMasterCardAutomatic]: 'mastercard_automatic',
  [DepositMode.safeChargeVisaAutomatic]: 'visa_automatic',
  [DepositMode.mbWay]: 'mbWay',
  [DepositMode.bizum]: 'Bizum',
  [DepositMode.multibanco]: 'multibanco',
  [DepositMode.applepayAutomatic]: 'applepay_automatic',
} as const;

// Use this mapping to convert DepositMode keys to their corresponding descriptions
// For now, the analytics names can be used as descriptions, if the need arises
// just create a new mapping object with the desired descriptions.
export const rechargeMethodDescription = rechargeMethodToAnalyticName;

export type AnalyticsPaymentMethod =
  (typeof rechargeMethodToAnalyticName)[DepositModeKey];

export const allRechargesDepositModeIds = Object.values(DepositMode);

export const topupsFaqUrl =
  APP_VENDOR === 'pokerstars'
    ? `${MAIN_SITE_HOMEPAGE}assistenza/ricariche`
    : `${MAIN_SITE_HOMEPAGE}faq/ricariche`;

export const paymentInstitutesUrl = 'https://www.clackpay.net/points';
